import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={66}
        height={85}
        viewBox="0 0 428 546"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M337.602 166.7C337.702 162.2 337.702 166.1 337.602 166.7V166.7Z"
            fill="black"
        />
        <path
            d="M404.101 165.4H338.901V163.5C338.901 159.2 338.901 149.6 338.901 129.8C338.901 110 338.901 80.0996 338.901 34.9996C338.901 15.7996 323.301 0.0996094 304.101 0.0996094H35.1008C15.9008 0.0996094 0.300781 15.6996 0.300781 34.9996V512.2C1.10078 530.8 16.4008 545.6 35.1008 545.6H304.101C323.301 545.6 338.901 530 338.901 510.8V508.8V508.4C338.901 500.4 338.901 469.1 338.801 364.8H404.001C417.201 364.8 427.801 354.1 427.801 341V189.2C428.001 176 417.301 165.4 404.101 165.4ZM337.701 166.7C337.701 162.2 337.701 166.1 337.701 166.7V166.7ZM19.7008 34.9996C19.7008 26.4996 26.6008 19.5996 35.2008 19.5996H304.201C312.701 19.5996 319.501 26.4996 319.501 34.9996V74.1996H19.7008V34.9996ZM19.7008 93.6996H319.501V165.4H203.101V136C203.101 125.4 194.501 116.8 183.901 116.8H127.301C116.701 116.8 108.101 125.4 108.101 136V394C108.101 404.6 116.701 413.2 127.301 413.2H183.901C194.501 413.2 203.101 404.6 203.101 394V364.7H319.501V436.3H19.7008V93.6996ZM155.601 147.8C150.201 147.8 145.801 152.2 145.801 157.6V372.7C145.801 378.1 150.201 382.5 155.601 382.5C161.001 382.5 165.401 378.1 165.401 372.7V364.8H183.601V393.9H127.601V136.4H183.601V165.4H165.401V157.5C165.401 152.2 161.001 147.8 155.601 147.8ZM165.401 214.8H191.201L191.101 242.3H165.401V214.8ZM304.101 526.1H35.1008C26.6008 526.1 19.8008 519.2 19.8008 510.8V456H319.601V509.6H319.501V510.8C319.501 519.2 312.601 526.1 304.101 526.1ZM408.601 341C408.601 343.4 406.601 345.3 404.201 345.3H165.401V322.6H178.601C184.001 322.6 188.401 318.2 188.401 312.8C188.401 307.4 184.001 303 178.601 303H165.401V261.6H192.401C202.501 261.6 210.701 253.3 210.701 243.1V213.5C210.701 203.3 202.401 195 192.201 195H165.401V184.6H404.201C406.601 184.7 408.601 186.6 408.601 189V341Z"
            fill="url(#paint0_linear_8042_28142)"
        />
        <path
            d="M169.602 463.899C154.602 463.899 142.402 476.099 142.402 490.999C142.402 498.199 145.102 504.999 150.202 510.099C155.402 515.299 162.202 518.099 169.502 518.099C184.502 518.099 196.702 505.899 196.702 490.899C196.802 476.099 184.602 463.899 169.602 463.899ZM169.602 498.799C165.302 498.799 161.802 495.299 161.802 490.999C161.802 486.699 165.302 483.199 169.602 483.199C173.902 483.199 177.402 486.699 177.402 490.999C177.402 495.299 173.902 498.799 169.602 498.799Z"
            fill="url(#paint1_linear_8042_28142)"
        />
        <path
            d="M204.002 46.8C204.002 52.2 199.602 56.6 194.202 56.6H144.902C139.502 56.6 135.102 52.2 135.102 46.8C135.102 41.4 139.502 37 144.902 37H194.202C199.602 37.1 204.002 41.5 204.002 46.8Z"
            fill="url(#paint2_linear_8042_28142)"
        />
        <path
            d="M239.302 53.6998C237.502 55.4998 234.902 56.5998 232.302 56.5998H232.202C229.602 56.5998 227.202 55.5998 225.402 53.6998C223.602 51.9998 222.602 49.5998 222.602 46.9998C222.602 44.3998 223.602 41.7998 225.402 39.9998C229.002 36.3998 235.402 36.3998 239.202 39.9998C243.002 43.8998 243.002 49.7998 239.302 53.6998Z"
            fill="url(#paint3_linear_8042_28142)"
        />
        <path
            d="M389.502 211.499C389.502 216.899 385.102 221.299 379.702 221.299H316.402C311.002 221.299 306.602 216.899 306.602 211.499C306.602 206.099 311.002 201.699 316.402 201.699H379.702C385.102 201.799 389.502 206.199 389.502 211.499Z"
            fill="url(#paint4_linear_8042_28142)"
        />
        <path
            d="M389.5 239.8C389.5 245.2 385.1 249.6 379.7 249.6H246.3C240.9 249.6 236.5 245.2 236.5 239.8C236.5 234.4 240.9 230 246.3 230H379.8C385.2 230.1 389.5 234.5 389.5 239.8Z"
            fill="url(#paint5_linear_8042_28142)"
        />
        <path
            d="M255.502 312.999C255.502 318.399 251.102 322.799 245.702 322.799H216.902C211.502 322.799 207.102 318.399 207.102 312.999C207.102 307.599 211.502 303.199 216.902 303.199H245.702C251.102 303.199 255.502 307.599 255.502 312.999Z"
            fill="url(#paint6_linear_8042_28142)"
        />
        <path
            d="M322.502 312.999C322.502 318.399 318.102 322.799 312.702 322.799H283.902C278.502 322.799 274.102 318.399 274.102 312.999C274.102 307.599 278.502 303.199 283.902 303.199H312.702C318.102 303.199 322.502 307.599 322.502 312.999Z"
            fill="url(#paint7_linear_8042_28142)"
        />
        <path
            d="M389.599 312.999C389.599 318.399 385.199 322.799 379.799 322.799H350.999C345.599 322.799 341.199 318.399 341.199 312.999C341.199 307.599 345.599 303.199 350.999 303.199H379.799C385.199 303.199 389.599 307.599 389.599 312.999Z"
            fill="url(#paint8_linear_8042_28142)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_8042_28142"
                x1={29.2993}
                y1={-45.1688}
                x2={327.592}
                y2={594.523}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.1048} stopColor="#01E9BD" />
                <stop offset={0.2148} stopColor="#01B8B5" />
                <stop offset={0.3264} stopColor="#028EAF" />
                <stop offset={0.4352} stopColor="#026DAA" />
                <stop offset={0.5389} stopColor="#0255A6" />
                <stop offset={0.6353} stopColor="#0247A4" />
                <stop offset={0.7172} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_8042_28142"
                x1={95.5666}
                y1={332.294}
                x2={200.674}
                y2={557.698}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.0103541} stopColor="#01DDBB" />
                <stop offset={0.0472026} stopColor="#01B9B6" />
                <stop offset={0.0886636} stopColor="#0199B0" />
                <stop offset={0.1345} stopColor="#027DAC" />
                <stop offset={0.1863} stopColor="#0267A9" />
                <stop offset={0.2467} stopColor="#0256A6" />
                <stop offset={0.3214} stopColor="#024BA4" />
                <stop offset={0.4262} stopColor="#0244A3" />
                <stop offset={0.7172} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_8042_28142"
                x1={161.049}
                y1={28.5726}
                x2={245.983}
                y2={210.714}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.1397} stopColor="#01B2B4" />
                <stop offset={0.2803} stopColor="#0282AD" />
                <stop offset={0.4044} stopColor="#025FA8" />
                <stop offset={0.506} stopColor="#024AA4" />
                <stop offset={0.5722} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_8042_28142"
                x1={217.683}
                y1={15.3332}
                x2={299.939}
                y2={191.732}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.0158959} stopColor="#01E9BD" />
                <stop offset={0.1517} stopColor="#01B2B4" />
                <stop offset={0.2884} stopColor="#0282AD" />
                <stop offset={0.4091} stopColor="#025FA8" />
                <stop offset={0.5078} stopColor="#024AA4" />
                <stop offset={0.5722} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_8042_28142"
                x1={294.941}
                y1={97.6099}
                x2={398.897}
                y2={320.542}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.0757161} stopColor="#01DABB" />
                <stop offset={0.2203} stopColor="#01B4B5" />
                <stop offset={0.4171} stopColor="#0277AB" />
                <stop offset={0.5722} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_8042_28142"
                x1={273.124}
                y1={154.28}
                x2={373.937}
                y2={370.474}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.00303614} stopColor="#01E7BD" />
                <stop offset={0.0668411} stopColor="#01C0B7" />
                <stop offset={0.1356} stopColor="#019FB1" />
                <stop offset={0.2121} stopColor="#0282AD" />
                <stop offset={0.2969} stopColor="#026AA9" />
                <stop offset={0.3934} stopColor="#0258A6" />
                <stop offset={0.5086} stopColor="#024BA4" />
                <stop offset={0.6612} stopColor="#0244A3" />
                <stop offset={1} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_8042_28142"
                x1={213.878}
                y1={275.54}
                x2={266.079}
                y2={387.485}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.00124253} stopColor="#01E8BD" />
                <stop offset={0.0497761} stopColor="#01C1B7" />
                <stop offset={0.1021} stopColor="#019FB2" />
                <stop offset={0.1601} stopColor="#0282AD" />
                <stop offset={0.2244} stopColor="#026AA9" />
                <stop offset={0.2974} stopColor="#0258A6" />
                <stop offset={0.3843} stopColor="#024CA4" />
                <stop offset={0.4987} stopColor="#0244A3" />
                <stop offset={0.7485} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_8042_28142"
                x1={275.212}
                y1={263.388}
                x2={337.945}
                y2={397.92}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.00124253} stopColor="#01E8BD" />
                <stop offset={0.0497761} stopColor="#01C1B7" />
                <stop offset={0.1021} stopColor="#019FB2" />
                <stop offset={0.1601} stopColor="#0282AD" />
                <stop offset={0.2244} stopColor="#026AA9" />
                <stop offset={0.2974} stopColor="#0258A6" />
                <stop offset={0.3843} stopColor="#024CA4" />
                <stop offset={0.4987} stopColor="#0244A3" />
                <stop offset={0.7485} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_8042_28142"
                x1={336.933}
                y1={251.859}
                x2={397.861}
                y2={382.52}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.00949245} stopColor="#01DDBB" />
                <stop offset={0.0432746} stopColor="#01B9B6" />
                <stop offset={0.0812854} stopColor="#0199B0" />
                <stop offset={0.1233} stopColor="#027DAC" />
                <stop offset={0.1708} stopColor="#0267A9" />
                <stop offset={0.2262} stopColor="#0256A6" />
                <stop offset={0.2947} stopColor="#024BA4" />
                <stop offset={0.3908} stopColor="#0244A3" />
                <stop offset={0.6575} stopColor="#0242A3" />
            </linearGradient>
        </defs>
    </svg>
);
export default SVGComponent;
